const currencies = ['AUD', 'CHF', 'CNY', 'DKK', 'EUR', 'GBP', 'HKD', 'JPY', 'SEK', 'SGD', 'USD'];

export default currencies;